import { Skeleton } from "@/components/skeleton";

const SKELETON_CARDS = 2;

export function PaymentMethodsSkeleton() {
  return (
    <div
      aria-busy="true"
      aria-label="Loading payment methods"
      className="flex flex-col gap-xl p-xl md:flex-row md:gap-3xl md:pt-3xl"
    >
      {Array.from({ length: SKELETON_CARDS }, (_, index) => (
        <div
          className="flex min-w-0 flex-1 flex-col gap-md rounded-md border border-border-secondary p-3xl"
          key={index}
        >
          <Skeleton className="h-4.5 w-28" />
          <div className="flex items-center gap-lg">
            <Skeleton className="h-16 w-23 rounded-md" />
            <div className="flex flex-1 flex-col gap-xs">
              <Skeleton className="h-6 w-44" />
              <Skeleton className="h-4.5 w-20" />
            </div>
          </div>
          <Skeleton className="mt-md h-5 w-48" />
        </div>
      ))}
    </div>
  );
}
